// extracted by mini-css-extract-plugin
export var alt = "FeeDescriptionTooltip-module--alt--73542";
export var desktopOnly = "FeeDescriptionTooltip-module--desktopOnly--93b64";
export var main = "FeeDescriptionTooltip-module--main--ffd9e";
export var mobileOnly = "FeeDescriptionTooltip-module--mobileOnly--90df4";
export var textLeft = "FeeDescriptionTooltip-module--textLeft--5e503";
export var tooltip = "FeeDescriptionTooltip-module--tooltip--ea5a2";
export var visuallyHidden = "FeeDescriptionTooltip-module--visuallyHidden--90d19";